export const rupiah = (n) => {
  if (n == null || isNaN(n)) return "Rp0";
  return "Rp" + Math.round(n).toLocaleString("id-ID");
};

export const fmtDate = (s, lang = "id") => {
  if (!s) return "-";
  try {
    const d = new Date(s);
    return d.toLocaleDateString(lang === "id" ? "id-ID" : "en-US", {
      day: "numeric", month: "short", year: "numeric",
    });
  } catch {
    return s;
  }
};

export const fmtTime = (s) => {
  if (!s) return "";
  try {
    return new Date(s).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  } catch {
    return "";
  }
};

export const STATUS_STEPS = [
  "PAYMENT_COMPLETED", "ITEM_PURCHASED", "TRAVELING", "ARRIVED", "LOCAL_DELIVERY", "COMPLETED",
];

export const STATUS_LABELS = {
  REQUEST_SENT: "Request Sent", QUOTATION_SENT: "Quotation Sent",
  PAYMENT_PENDING: "Payment Pending", PAYMENT_COMPLETED: "Paid & Held",
  PURCHASE_PENDING: "Purchase Pending", ITEM_PURCHASED: "Item Purchased",
  TRAVELING: "On The Way", ARRIVED: "Arrived", LOCAL_DELIVERY: "Out for Delivery",
  RECEIVED: "Received", COMPLETED: "Completed", DISPUTED: "Disputed",
  CANCELLED: "Cancelled", REFUNDED: "Refunded",
};
